export const validateImageResolution = (
  file: File,
  maxWidth: number,
  maxHeight: number
): Promise<boolean> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const image = new Image();
      image.onload = () => {
        const isResolutionValid =
          image.width <= maxWidth && image.height <= maxHeight;
        resolve(isResolutionValid);
      };
      image.src = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  });
};
